//
import { PropTypes } from "prop-types";
import React from "react";
import { injectIntl } from "react-intl";

import deepGetSet from "../../api/deepGetSet";
import PreferenceCenterAPI from "../../api/preferencecenter/PreferenceCenterAPI";

import Notification from "../../components/common/notification/Notification";
import Personalization from "../common/personalization/Personalization";

import PreferenceCenterDatiPersonali from "./PreferenceCenterDatiPersonali";
import PreferenceCenterDatiPersonaliExport from "./PreferenceCenterDatiPersonaliExport";
import PreferenceCenterSocial from "./PreferenceCenterSocial";
import PreferenceCenterSubscription from "./PreferenceCenterSubscription";
import WelcomeMessage from "./WelcomeMessage";

import FrontendException from "../../models/FrontendException";
import InvalidSubscriberDataException from "../../models/InvalidSubscriberDataException";
import LoadingSpinner from "../common/spinner/LoadingSpinner";

class PreferenceCenter extends React.Component {
	constructor() {
		super();
		//
		this.mounted = false;
		//
		this.introElementRef = React.createRef();
		this.notificationRef = React.createRef();
		//
		this.defaultListValues = { optout_title: "..." };
		this.subscriberEmail = "";
		this.prefOptions = {}; // opzioni di preference center
		this.prefText = {
			textIntroDefault: "",
		}; //  messaggi testuali da impostazioni preference center

		//
		this.state = {
			loading: false,
			showError: false,
			showIntro: false,
			showMainContent: false,
			showSubscription: false,
			showDatiPersonali: false,
			showDatiPersonaliExport: false,
			showSocial: false,
			showPrivacy: false,

			errorLabel: "",

			welcomeMessage: "", //  messaggio di benvenuto contenente [email] placeholder
		};
	}

	componentDidMount() {
		this.mounted = true;
		const params = this.props.match.params;
		document.title = this.props.intl.formatMessage({
			id: "Load.PreferenceCenter.PageTitle",
			defaultMessage: "Load.PreferenceCenter.PageTitle",
		});
		//
		this.startLoader();
		//
		if (this.isTrue(this.props.match.params.dl)) {
			//  gestione list deleted..
			Promise.all([this.getSubscriberEmail(), this.getDefaultListValues()])
				.then(() => {
					this.notificationRef.current.addInfo(
						this.defaultListValues.optout_title,
						"dl",
						false,
						false,
					);
				})
				.catch((error) => this.handleError(error, "dl"))
				.finally(this.stopLoader);
		} else if (!this.isUserParamsValid()) {
			//  do not use setState directly in componentDidMount
			this.handleError("Load.PreferenceCenter.ErrorUserParams");
		} else {
			//  ..  loading...
			Promise.all([this.getSubscriberEmail(), this.loadPrefCenterOptions()])
				.then(() => {
					if (this.mounted) {
						this.setState({
							showIntro: true,
							showMainContent: true,
							showSubscription: true,
							showDatiPersonali:
								this.prefOptions.EnableProfilation &&
								this.prefOptions.IdForm > 0,
							showDatiPersonaliExport: this.prefOptions.EnableExport,
							showSocial: this.prefOptions.EnableSocial,
							showPrivacy: this.prefOptions.EnablePrivacy,
							welcomeMessage: this.prefText["textIntroDefault"],
						});
					}
				})
				.catch((error) => {
					//  console.log('error', error);
					this.handleError(error, "default", true);
				})
				.finally(this.stopLoader);
		}
		//
	}

	componentWillUnmount() {
		this.mounted = false;
	}

	//  componentDidUpdate() {

	/*
  //  surround email with <strong></strong>
  //  crash con effetto loading attivo (prima dice che ha match, poi dice che index è out of bounds..)
  const intro = this.introElementRef.current;
  if(intro) {
    const regexMatch = RegexAPI.containsEmail().exec(intro.innerHTML);
    if(regexMatch && regexMatch.index && regexMatch[0]) {
      const range = document.createRange();
      range.setStart(intro.firstChild, regexMatch.index);
      range.setEnd(intro.firstChild, regexMatch.index + regexMatch[0].length);

      const surrounding = document.createElement("strong");
      range.surroundContents(surrounding);
    }
  }
  */

	//  }

	/**
	 * Verifica parametri id, idList, hash
	 * se vuoti/nulli ritorna false
	 *
	 *
	 */
	isUserParamsValid() {
		const params = this.props.match.params;
		//
		return Boolean(params.id && params.idList && params.hash);
	}

	isTrue(paramValue) {
		return "true" == paramValue || "1" == paramValue || "on" == paramValue;
	}

	isString(param) {
		return typeof param === "string" || param instanceof String;
	}

	/**
	 * Load email subscriber a partire da idOptin e hash
	 *
	 *
	 */
	getSubscriberEmail() {
		const params = this.props.match.params;
		//
		return PreferenceCenterAPI.getSubscriberEmail(params.id, params.hash).then(
			(email) => {
				if (!email) {
					throw new InvalidSubscriberDataException();
				} else {
					this.subscriberEmail = email;
				}
			},
		);
	}

	/**
	 * Load opzioni di preference center
	 *
	 *
	 */
	loadPrefCenterOptions() {
		const params = this.props.match.params;
		const intl = this.props.intl;
		//
		return PreferenceCenterAPI.loadPrefCenterOptions(
			params.id,
			params.hash,
			params.idList,
		).then((prefOptions) => {
			//
			this.prefOptions = prefOptions;
			//
			let prefText = JSON.parse(prefOptions.Configuration || "{}");
			//
			if (
				!deepGetSet(prefText, "subUnsubData.sectionTitle") ||
				deepGetSet(prefText, "subUnsubData.sectionTitle") ===
					".Load.PreferenceCenter.SectionTitleSubUnsubDefault"
			) {
				deepGetSet(
					prefText,
					"subUnsubData.sectionTitle",
					intl.formatMessage({
						id: "Load.PreferenceCenter.SectionTitleSubUnsubDefault",
						defaultMessage: "Load.PreferenceCenter.SectionTitleSubUnsubDefault",
					}),
				);
			}
			//
			if (
				!deepGetSet(prefText, "trackStatData.sectionTitle") ||
				deepGetSet(prefText, "trackStatData.sectionTitle") ===
					".Load.PreferenceCenter.SectionTitleTrackStatDataDefault"
			) {
				deepGetSet(
					prefText,
					"trackStatData.sectionTitle",
					intl.formatMessage({
						id: "Load.PreferenceCenter.SectionTitleTrackStatDataDefault",
						defaultMessage:
							"Load.PreferenceCenter.SectionTitleTrackStatDataDefault",
					}),
				);
			}
			//
			if (
				!deepGetSet(prefText, "personalizationData.textIntro") ||
				deepGetSet(prefText, "personalizationData.textIntro") ===
					".Load.PreferenceCenter.TextIntroDefault [email]"
			) {
				deepGetSet(
					prefText,
					"personalizationData.textIntro",
					intl.formatMessage({
						id: "Load.PreferenceCenter.TextIntroDefault",
						defaultMessage: "Load.PreferenceCenter.TextIntroDefault",
					}),
				);
			}

			if (
				!deepGetSet(prefText, "personalizationData.callToAction") ||
				deepGetSet(prefText, "personalizationData.callToAction") ===
					".Load.PreferenceCenter.CallToActionDefault"
			) {
				deepGetSet(
					prefText,
					"personalizationData.callToAction",
					intl.formatMessage({
						id: "Load.PreferenceCenter.CallToActionDefault",
						defaultMessage: "Load.PreferenceCenter.CallToActionDefault",
					}),
				);
			}

			if (
				!deepGetSet(prefText, "personalData.downloadText") ||
				deepGetSet(prefText, "personalData.downloadText") ===
					".Load.PreferenceCenter.DownloadTextDefault"
			) {
				deepGetSet(
					prefText,
					"personalData.downloadText",
					intl.formatMessage({
						id: "Load.PreferenceCenter.DownloadTextDefault",
						defaultMessage: "Load.PreferenceCenter.DownloadTextDefault",
					}),
				);
			}
			//
			this.prefText = prefText;
			//
		});
	}

	getDefaultListValues() {
		const params = this.props.match.params;
		//
		return PreferenceCenterAPI.getDefaultListValues(
			params.id,
			params.hash,
		).then((defaultListValues) => {
			this.defaultListValues = defaultListValues;
		});
	}

	handleError = (error, source = "default", fatal = false) => {
		//  console.log("PreferenceCenter handleError", error);
		let errorLabel = "Load.Common.Error";
		if (error instanceof FrontendException) {
			errorLabel = error.label;
		} else if (
			error.hasOwnProperty("type") &&
			error.type == "FrontendException"
		) {
			errorLabel = "Load.PreferenceCenter.ErrorUserParams";
		} else if (this.isString(error)) {
			errorLabel = error;
		}
		//
		this.notificationRef.current.addError(
			this.props.intl.formatMessage({
				id: errorLabel,
				defaultMessage: errorLabel,
			}),
			source,
			false,
			!fatal,
		);
	};

	handleSubscriptionOnSave = () => {
		//
		if (this.notificationRef && this.notificationRef.current) {
			this.notificationRef.current.addSuccess(
				this.props.intl.formatMessage({
					id: "Load.PreferenceCenter.SaveOK",
					defaultMessage: "Load.PreferenceCenter.SaveOK",
				}),
			);
		}
	};

	handleSubscriptionOnError = (message) => {
		//
		if (this.notificationRef && this.notificationRef.current) {
			this.notificationRef.current.addError(message);
		}
	};

	startLoader = () => {
		if (this.mounted) {
			this.setState({
				loading: true,
			});
		}
	};

	stopLoader = () => {
		if (this.mounted) {
			this.setState({
				loading: false,
			});
		}
	};

	testNotification = () => {
		const notification = this.notificationRef.current;
		//
		notification.addSuccess("test success no source 1", "default", false, true);
		notification.addSuccess("test success no source 2");
		//
		notification.addSuccess("message with source a", "a");
		notification.addSuccess("another message with source a", "a");
		//
		notification.addError("message with close button", "default", false, true);
		notification.addInfo("info message", "default", false, true);
		notification.addWarning("warning message", "default", false, true);
	};

	render() {
		const datiPersonaliProps = {
			idList: parseInt(this.props.match.params.idList, 10),
			msg: this.props.match.params.idNL
				? parseInt(this.props.match.params.idNL, 10)
				: 0,
			idForm: this.prefOptions.IdForm,
			email: this.subscriberEmail,
			idOptin: parseInt(this.props.match.params.id, 10),
			hash: this.props.match.params.hash,
			prefTexts: this.prefText,
		};

		const subscriptionProps = {
			prefTexts: this.prefText,
			prefList: this.prefOptions.Lists,
			showTracking: this.prefOptions.EnableTracking,
			idOptin: parseInt(this.props.match.params.id, 10),
			hash: this.props.match.params.hash,
			idList: parseInt(this.props.match.params.idList, 10),
			idNL: this.props.match.params.idNL
				? parseInt(this.props.match.params.idNL, 10)
				: 0,
			onSave: this.handleSubscriptionOnSave,
			onError: this.handleSubscriptionOnError,
		};
		//

		const socialProps = {
			links: this.prefOptions.SocialLinks,
		};

		//
		return (
			<div>
				<Notification ref={this.notificationRef} />
				{this.state.loading && <LoadingSpinner />}

				{this.state.showIntro && (
					<div className="pref-center_intro">
						<h2 ref={this.introElementRef}>
							<WelcomeMessage
								src={this.prefText.personalizationData.textIntro}
								email={this.subscriberEmail}
							/>
						</h2>{" "}
						{/* dangerouslySetInnerHTML={{__html: welcomeMessage}} */}
					</div>
				)}

				{/* <button onClick={this.testNotification}>test notification</button> */}

				{this.state.showMainContent && (
					<div className="frontend-wrapper">
						<Personalization
							idList={this.props.match.params.idList}
							showLogo
							applyCustomCSS
						/>

						{/* Box per iscrizione e tracciamento */}
						{this.state.showSubscription && (
							<PreferenceCenterSubscription {...subscriptionProps} />
						)}

						{/* Box per form autoprofilazione */}
						{this.state.showDatiPersonali && (
							<PreferenceCenterDatiPersonali {...datiPersonaliProps} />
						)}

						{/* Box per form download dati autoprofilazione */}
						{this.state.showDatiPersonaliExport && (
							<PreferenceCenterDatiPersonaliExport {...datiPersonaliProps} />
						)}

						{/* Box con social */}
						{this.state.showSocial && (
							<PreferenceCenterSocial {...socialProps} />
						)}
					</div>
				)}

				{this.state.showMainContent && this.state.showPrivacy && (
					<div className="frontend-row pref-center_footer">
						{deepGetSet(this.prefText, "personalizationData.privacy") && (
							<p className="frontend-note">
								{deepGetSet(this.prefText, "personalizationData.privacy")}
							</p>
						)}
					</div>
				)}
			</div>
		);
	}
}

PreferenceCenter.propTypes = {
	match: PropTypes.shape({
		params: PropTypes.shape({
			id: PropTypes.string.isRequired,
			hash: PropTypes.string.isRequired,
			idList: PropTypes.string.isRequired,
			idNL: PropTypes.string,
			dl: PropTypes.string,
		}),
	}),
};

export default injectIntl(PreferenceCenter);
